import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  VStack,
  Heading,
  Text,
  SimpleGrid,
  Box,
  Image,
  useColorModeValue,
  Card,
  CardBody,
} from '@chakra-ui/react';
import { useLeague } from '../context/LeagueContext';
import { LeagueId } from '../types';

const LEAGUES: { id: LeagueId; name: string; image: string; description: string }[] = [
  {
    id: 'liga_mx',
    name: 'Liga BBVA MX',
    image: '/images/ligamx_logo.png',
    description: 'Pronósticos de la Liga MX',
  },
  {
    id: 'mundial_fifa',
    name: 'Mundial FIFA 2026',
    image: '/images/mundial_2026.png',
    description: 'Pronósticos del Mundial de la FIFA',
  },
];

const LeagueSelectionPage: React.FC = () => {
  const navigate = useNavigate();
  const { setLeague } = useLeague();
  const cardBg = useColorModeValue('white', 'gray.800');
  const cardHoverBg = useColorModeValue('gray.50', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  // Fondo solo para las imágenes: en modo oscuro más claro para que los logos se vean bien
  const imageBg = useColorModeValue('gray.50', 'gray.600');

  const handleSelect = (leagueId: LeagueId) => {
    setLeague(leagueId);
    navigate('/');
  };

  return (
    <Container maxW="container.lg" py={{ base: 6, md: 10 }} px={{ base: 4, md: 6 }}>
      <VStack spacing={8} align="stretch">
        <Heading textAlign="center" size="xl">
          Selecciona una competencia
        </Heading>
        <Text textAlign="center" color="gray.600" fontSize="lg">
          Elige la quiniela en la que quieres participar
        </Text>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} w="full">
          {LEAGUES.map((league) => (
            <Card
              key={league.id}
              bg={cardBg}
              borderWidth="2px"
              borderColor={borderColor}
              cursor="pointer"
              onClick={() => handleSelect(league.id)}
              _hover={{
                borderColor: 'blue.400',
                bg: cardHoverBg,
                transform: 'translateY(-2px)',
                boxShadow: 'lg',
              }}
              transition="all 0.2s"
            >
              <CardBody>
                <VStack spacing={4}>
                  <Box
                    w="full"
                    h="200px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bg={imageBg}
                    borderRadius="lg"
                    p={4}
                  >
                    <Image
                      src={league.image}
                      alt={league.name}
                      maxH="180px"
                      objectFit="contain"
                    />
                  </Box>
                  <Heading size="md" textAlign="center">
                    {league.name}
                  </Heading>
                  <Text textAlign="center" color="gray.600">
                    {league.description}
                  </Text>
                </VStack>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      </VStack>
    </Container>
  );
};

export default LeagueSelectionPage;
